





































import { computed, defineComponent, ref } from "@vue/composition-api";
import { Review } from "@scrile/api-provider/dist/api/ReviewProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import useAuthUser from "@/hooks/useAuthUser";
import { REVIEW_COUNT_LIMIT } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import BaseInputBox from "@/components/BaseInputBox";
import BaseSendMessage from "@/components/BaseSendMessage";
import SendMessageController from "@/components/SendMessageController";
import ReviewRemoveConfirm from "./components/ReviewRemoveConfirm.vue";
import ReviewsFullListController from "./components/ReviewsFullListController.vue";
import ReviewsItem from "./components/ReviewsItem.vue";
import ReviewsSendController from "./components/ReviewsSendController.vue";

export default defineComponent({
  name: "FeedReviews",
  components: {
    ReviewRemoveConfirm,
    BaseConfirm,
    BaseButton,
    ReviewsFullListController,
    ReviewsSendController,
    ReviewsItem,
    BaseSendMessage,
    BaseInputBox,
    BaseIcon,
    SendMessageController,
  },
  props: {
    isAuthor: { type: Boolean, default: false },
    postId: { type: String, required: true },
    reviewStatsCount: { type: Number, required: true },
    reviews: { type: Array as () => Review[], required: true },
  },
  setup(props, { emit }) {
    const { authUser } = useAuthUser();
    const showModal = ref(false);
    const showConfirm = ref(false);
    const removeReviewId = ref("");

    const modalCb = useAuthorisedOnly(() => {
      showModal.value = true;
    });
    emit("modal-cb:show", () => modalCb());

    const manyReviews = computed(() => props.reviewStatsCount > REVIEW_COUNT_LIMIT);

    const onAddReview = (r: Review) => {
      emit("update:addCountReview", props.reviewStatsCount + 1, r);
    };

    const showRemoveConfirm = (id: string) => {
      showConfirm.value = true;
      removeReviewId.value = id;
    };

    const isReviewAuthor = (review: Review) => review.reviewerId === authUser.value?.id;

    const onRemoveReviewCb = (reviewId: string) => {
      emit("update:decreaseCountReview", props.reviewStatsCount - 1, reviewId);
      showConfirm.value = false;
    };

    const toggleModal = () => {
      showModal.value = !showModal.value;
    };

    return {
      showModal,
      toggleModal,
      manyReviews,
      onAddReview,
      onRemoveReviewCb,
      isReviewAuthor,
      showConfirm,
      showRemoveConfirm,
      removeReviewId,
    };
  },
});
